import styled from 'styled-components';
import HappyGoSafeLogoSvg from './goSafeLogo.svg';

const HappyGoSafeLogo = styled(HappyGoSafeLogoSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '3rem'};
  height: ${props => props.height || '3rem'};
  margin: ${props => props.margin};
`;

export default HappyGoSafeLogo;
